
import React from 'react';
import Dialog from '@kufox/mui/Dialog';
import { NoSSG } from "../../common/tools";

export default function NoSSGModal({ children, ...props }) {
  return (
    <NoSSG>
      <Dialog {...props}>
        {children}
      </Dialog>
    </NoSSG>
  );
}